<div class="full-width flex flex-row justify-between items-center">
  <h2 data-at-title>
    {{ '+BOOKING.OVERVIEW.PACKAGES.TEST_VERSION' | translate }}
  </h2>
  <!-- uncomment after VIG-5482 -->
  <!-- <ng-container
    *ngIf="bookingStore.trialSubscriptionsActiveOnlineOnly$ | async as activeOnlineOnly"
  >
    <button
      class="full-width assign-btn"
      data-at-assign-all-device-button
      mat-raised-button
      color="primary"
      gtm="onGoToPage"
      gtmAction="Booking"
      gtmCategory="Booking"
      (click)="onExtendAll()"
      [disabled]="activeOnlineOnly?.length === 0"
    >
      {{
        '+INSTALLATIONS.INSTALLATIONS.TRIAL_BANNER.HEADER'
          | translate: { number: activeOnlineOnly?.length }
      }}
    </button>
  </ng-container> -->
</div>

<app-chip-filters [layoutGap]="'8px'">
  <app-chip-filter
    [active]="currentFilter === filterType.ALL"
    [count]="trialSubscriptionsActive?.length"
    gtm="onSetFilter"
    gtmAction="All devices"
    gtmCategory="bookingOverview"
    (click)="setFilter(filterType.ALL)"
    >{{ '+BOOKING.OVERVIEW.FILTER.TRIAL_ALL_DEVICES' | translate }}</app-chip-filter
  >
  <app-chip-filter
    [active]="currentFilter === filterType.ONLINE"
    [count]="trialSubscriptionsActiveOnlineOnly?.length"
    gtm="onSetFilter"
    gtmAction="Online devices"
    gtmCategory="bookingOverview"
    (click)="setFilter(filterType.ONLINE)"
    >{{ '+BOOKING.OVERVIEW.FILTER.TRIAL_ONLINE_DEVICES' | translate }}</app-chip-filter
  >
  <app-chip-filter
    [active]="currentFilter === filterType.OFFLINE"
    [count]="trialActiveSubscriptionsOfflineForBooking?.length"
    gtm="onSetFilter"
    gtmAction="Offline devices"
    gtmCategory="bookingOverview"
    (click)="setFilter(filterType.OFFLINE)"
    >{{ '+BOOKING.OVERVIEW.FILTER.TRIAL_OFFLINE_DEVICES' | translate }}</app-chip-filter
  >
</app-chip-filters>

<ng-container
  *ngIf="trialSubscriptions.length > 0; then showTrialSubscriptions; else noSubscriptions"
></ng-container>

<ng-template #showTrialSubscriptions>
  <div class="subscriptions-container">
    <ng-container *ngFor="let trialSubscription of trialSubscriptions">
      <app-booking-extend-trial-details
        [subscription]="trialSubscription"
      ></app-booking-extend-trial-details
    ></ng-container>
  </div>
</ng-template>

<ng-template #noSubscriptions>
  <div class="no-subscriptions">
    <app-no-search-results
      *ngIf="searchTerm; else noPackagesMessage"
      [searchTerm]="searchTerm"
    ></app-no-search-results>
    <ng-template #noPackagesMessage>
      <ng-container [ngSwitch]="currentFilter">
        <ng-container *ngSwitchCase="filterType.ALL">
          {{
            '+BOOKING.OVERVIEW.PACKAGES.NO_PACKAGES'
              | translate: { packageType: '+BOOKING.OVERVIEW.FILTER.TRIAL_ALL_DEVICES' | translate }
          }}
        </ng-container>
        <ng-container *ngSwitchCase="filterType.ONLINE">
          {{
            '+BOOKING.OVERVIEW.PACKAGES.NO_PACKAGES'
              | translate
                : { packageType: '+BOOKING.OVERVIEW.FILTER.TRIAL_ONLINE_DEVICES' | translate }
          }}
        </ng-container>
        <ng-container *ngSwitchCase="filterType.OFFLINE">
          {{
            '+BOOKING.OVERVIEW.PACKAGES.NO_PACKAGES'
              | translate
                : { packageType: '+BOOKING.OVERVIEW.FILTER.TRIAL_OFFLINE_DEVICES' | translate }
          }}
        </ng-container>
      </ng-container>
    </ng-template>
  </div>
</ng-template>
